module.exports = __webpack_public_path__ + "img/automotive-and-transportation.50630c62.svg";